/*******************************************************************************
 * Copyright (c) 2023 GetChkd
 *
 * All rights reserved.
 *
 * Contributors:
 *  James Worthington - Initial implementation
 *  Amina Rais - Massive Improvements
 *  Version: 2.0.0
 *
 *******************************************************************************/


import * as React from 'react';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import Paper from '@mui/material/Paper';
import StyledTableCell from '../../../../../../components/ui-elements/table/StyledTableCell';
import StyledTableRow from '../../../../../../components/ui-elements/table/StyledTableRow';
import { Select, MenuItem, Grid, InputLabel, FormControl } from "@mui/material";
import { useEffect } from 'react';
import { useState } from 'react';
import Loader from '../../../../../../components/ui-elements/loader';
import { useCallback } from 'react';
 import { useDispatch, useSelector } from 'react-redux';
import { getAllHashicorpUsers } from '../../../../../../store/reducers/hashicorp/hashicorpAction';
 
const HashicorpUsers = () => {
    const [loading, setLoading] = useState(false);
    const [authMethod, setAuthMethod] = useState("userpass");
    const users = useSelector(state => state.hashicorp.hashicorpUsers);
    const dispatch = useDispatch();


    const fetchUsers = useCallback(async () => {
        setLoading(true);
        try {
            await dispatch(getAllHashicorpUsers({ "authMethod": authMethod })).unwrap();

            setLoading(false);
        } catch (error) {
            setLoading(false);
        }
    }, [authMethod,dispatch]);

    useEffect(() => {
        fetchUsers()
    }, [fetchUsers]);

    return (
        <>
            {!loading ? <>
                <Grid container justify="center">
                    <Grid xs={12} sm={6} md={3} style={{ marginBottom: '20px' }}>
                        <FormControl fullWidth  >

                            <InputLabel htmlFor="outlined-Type">Auth Method</InputLabel>

                            <Select
                                value={authMethod}
                                variant="outlined"
                                name="authMethod"
                                label="Auth Method"
                                style={{ color: 'white' }}
                                onChange={(e) => setAuthMethod(e.target.value)}
                            >
                                <MenuItem value='userpass'>
                                    Userpass
                                </MenuItem>
                            </Select></FormControl>
                    </Grid>
                    <Grid xs={12} sm={12} md={12}>

                        <TableContainer component={Paper}>
                            <Table sx={{ minWidth: 700 }} aria-label="customized table">
                                <TableHead>
                                    <StyledTableRow>
                                        <StyledTableCell label="User Name" />

                                    </StyledTableRow>
                                </TableHead>
                                <TableBody>
                                    {users?.length > 0 && users?.map((row) => (
                                        <React.Fragment key={row}>

                                            <StyledTableRow >
                                                <StyledTableCell label={row} />

                                            </StyledTableRow>
                                        </React.Fragment>

                                    ))}
                                </TableBody>
                            </Table>
                        </TableContainer>
                    </Grid>
                </Grid>
            </> : (<Loader />)}

        </>
    )

}

export default HashicorpUsers;
